import React from "react";
import SidebarNav from "../organisms/SidebarNav";
import { useSidebarStore } from "../../stores/sidebarStore";

const Sidebar = () => {
  const {
    isSidebarExpanded,
    handleSidebarMouseEnter,
    handleSidebarMouseLeave,
  } = useSidebarStore();

  return (
    <aside
      className={`bg-gray-900 text-white transition-all duration-300 ease-in-out flex-shrink-0 ${
        isSidebarExpanded ? "w-64" : "w-16"
      }`}
    >
      <SidebarNav
        isExpanded={isSidebarExpanded}
        onMouseEnter={handleSidebarMouseEnter}
        onMouseLeave={handleSidebarMouseLeave}
      />
    </aside>
  );
};

export default Sidebar;
